import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { fetchPost, deleteAllCookies } from "../utils";

export default function Logout() {
  const history = useHistory();

  useEffect(() => {
    (async () => {
      window.localStorage.setItem("hub-userUuid", "");
      window.localStorage.setItem("hub-phone", "");
      window.localStorage.clear();
      deleteAllCookies();
      await fetchPost({
        url: "/api/logout",
        data: {},
        onError: console.error,
      });
      history.push("/");
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <h1>Logging out...</h1>;
}
